import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import refreshFinancingContent from 'commons/refreshFinancingContent';
import usePDPTieredPrice from 'data-hooks/usePDPTieredPrice';
import useUserData from 'data-hooks/useUserData';
import useAffirmRefreshHTML from 'hooks/useAffirmRefreshHTML';
import useIsBrowser from 'hooks/useIsBrowser';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import PDPFinancingUI from './PDPFinancingUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
const PDPFinancing = t0 => {
  const $ = _c(14);
  const {
    loading
  } = t0;
  const {
    isTradeUser
  } = useUserData();
  const isBrowser = useIsBrowser();
  const currentPage = useUserCurrentPageType();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    loading: priceLoading,
    priceDetails
  } = usePDPTieredPrice();
  const affirmButtonRef = useRef();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      deferLoad: true
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isAffirmContentReady = useAffirmRefreshHTML(affirmButtonRef, t1);
  const price = !priceDetails?.hasDiscount ? priceDetails?.priceWithOptionsPrice : priceDetails?.hasTieredDiscount ? priceDetails?.maxTieredDiscountedPrice : priceDetails?.salePriceWithOptionsPrice;
  const isLoading = loading || priceLoading;
  let t2;
  let t3;
  if ($[1] !== isAffirmContentReady || $[2] !== isTradeUser || $[3] !== price) {
    t2 = () => {
      if (price && isAffirmContentReady && !isTradeUser) {
        refreshFinancingContent();
      }
    };
    t3 = [price, isAffirmContentReady, isTradeUser];
    $[1] = isAffirmContentReady;
    $[2] = isTradeUser;
    $[3] = price;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== currentPage) {
    t4 = text => {
      avo.ctaClicked({
        text: text || "Affirm financing",
        targetUrl: "modal",
        cta: avo.Cta.FINANCING,
        component: avo.Component.PRODUCT_CARD,
        location: currentPage
      });
    };
    $[6] = currentPage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleAffirmClick = t4;
  if (isBrowser && isTradeUser) {
    return null;
  }
  let t5;
  if ($[8] !== handleAffirmClick || $[9] !== isAffirmContentReady || $[10] !== isLoading || $[11] !== pdpIsModularBYOProduct || $[12] !== price) {
    t5 = <PDPFinancingUI loading={isLoading} affirmButtonRef={affirmButtonRef} isAffirmContentReady={isAffirmContentReady} onAffirmClick={handleAffirmClick} pdpIsModularBYOProduct={pdpIsModularBYOProduct} price={price} />;
    $[8] = handleAffirmClick;
    $[9] = isAffirmContentReady;
    $[10] = isLoading;
    $[11] = pdpIsModularBYOProduct;
    $[12] = price;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
PDPFinancing.propTypes = {
  loading: PropTypes.bool
};
export default PDPFinancing;